// extracted by mini-css-extract-plugin
export default {"screen":"styles_screen__aO6yL","loader":"styles_loader__pQYp2"};